import { useState, type ReactNode } from "react";

// Components
import SidePanel from "./panel";

import Call from "src/models/call";

export default function PanelScript({ callDetails, togglePanel }: { callDetails: Call; togglePanel: Function }) {
  const [activeTab, setActiveTab] = useState<"inicio" | "regras" | "script_legado">("script_legado");

  return (
    <SidePanel panelName="Script" toggleAction={togglePanel}>
      {/* Tabs */}
      <div className="mb-4 flex items-center gap-2">
        <button
          type="button"
          onClick={() => setActiveTab("inicio")}
          className={`
            rounded-md px-2 py-1 text-sm font-semibold transition-colors
            ${activeTab === "inicio" ? "bg-[#7076a6] text-white" : "border border-[#7076a6] bg-white text-[#7076a6]"}
          `}
        >
          Início / Fim
        </button>

        <button
          type="button"
          onClick={() => setActiveTab("regras")}
          className={`
            rounded-md px-2 py-1 text-sm font-semibold transition-colors
            ${activeTab === "regras" ? "bg-[#ff6258] text-white" : "border border-[#ff6258] bg-white text-[#ff6258]"}
          `}
        >
          Regras
        </button>

        <button
          type="button"
          onClick={() => setActiveTab("script_legado")}
          className={`
            rounded-md px-2 py-1 text-sm font-semibold transition-colors
            ${activeTab === "script_legado" ? "bg-[#7076a6] text-white" : "border border-[#7076a6] bg-white text-[#7076a6]"}
          `}
        >
          Script Legado
        </button>
      </div>

      {/* Conteúdo da aba */}
      {activeTab === "inicio" && <InicioFim callDetails={callDetails} />}
      {activeTab === "regras" && <Regras callDetails={callDetails} />}
      {activeTab === "script_legado" && <ScriptLegado callDetails={callDetails} />}
    </SidePanel>
  );
}

function InicioFim({ callDetails }: { callDetails: Call }) {
  const { servico, aderenteName, aderenteVertical } = callDetails;

  return (
    <div className="grow overflow-y-auto flex flex-col h-0 gap-6">
      {aderenteVertical && (
        <Section title="Vertical de atuação">
          <p className="text-base font-bold">{aderenteVertical?.map((a, i) => `${a}${i + 1 < aderenteVertical.length ? ", " : ""}`) || ""}</p>
        </Section>
      )}

      <Section title="Empresa">
        <p className="mb-2 text-base font-bold">{aderenteName || ""}</p>

        <div className="flex h-33.25 items-center justify-center rounded-md bg-[#f4f5f9]">
          {servico.gif_sinal_empresa ? (
            <img src={servico.gif_sinal_empresa} alt="GIF Sinal" className="max-h-full max-w-full object-contain" />
          ) : (
            <span className="text-[11px] font-medium text-[#c6c9d5]">GIF Sinal</span>
          )}
        </div>
      </Section>

      <Section title="Apresentação">
        <div className="script-content space-y-1 text-base leading-[1.45]" dangerouslySetInnerHTML={{ __html: servico.script_apresentacao || "" }} />
      </Section>

      <section id="sondagem" className="bg-[#FEFFE5] p-2 rounded-md">
        <p className="mb-2 text-sm font-semibold text-[#6872a5]">Sondagem</p>

        <div className="script-content text-base" dangerouslySetInnerHTML={{ __html: servico.script_sondagem || "" }} />
      </section>

      <Section title="Encerramento">
        <div className="script-content space-y-1 text-base leading-[1.45] font-bold" dangerouslySetInnerHTML={{ __html: servico.script_encerramento || "" }} />
      </Section>
    </div>
  );
}

function Regras({ callDetails }: { callDetails: Call }) {
  const { servico } = callDetails;

  return (
    <div className="grow overflow-y-auto flex flex-col h-0 gap-6">
      <section id="sondagem" className="bg-[#FEFFE5] p-2 rounded-md">
        <p className="mb-2 text-sm font-semibold text-[#6872a5]">Sondagem</p>

        <div className="script-content text-base" dangerouslySetInnerHTML={{ __html: servico.script_sondagem || "" }} />
      </section>

      <section className="script-content leading-9" dangerouslySetInnerHTML={{ __html: servico.script_regras || "" }} />
    </div>
  );
}

function ScriptLegado({ callDetails }: { callDetails: Call }) {
  const { servico } = callDetails;

  return (
    <div className="grow overflow-y-auto flex flex-col h-0 gap-6">
      <div className="script-content space-y-1 text-base leading-[1.45]" dangerouslySetInnerHTML={{ __html: servico.script_para_atendimento || "" }} />
    </div>
  );
}

function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section>
      <p className="mb-2 text-sm font-semibold text-[#6872a5]">{title}</p>

      {children}
    </section>
  );
}
